import React from 'react';
import PropTypes from 'prop-types';

import JobNameView from './JobNameView';

const JobName = (props) => {
  const {
    jobData,
    client,
    jobBackend,
  } = props;

  return (
    <JobNameView
      jobData={jobData}
      client={client}
      jobBackend={jobBackend}
    />
  );
};

JobName.propTypes = {
  jobData: PropTypes.object.isRequired,
  client: PropTypes.object,
  jobBackend: PropTypes.object.isRequired,
};

export default React.memo(JobName);
